import React, { useState, useEffect, useRef } from "react";

interface TimerProps {
  initialTime: string; // Starting time in HH:MM:SS format
}

const TimerComponent: React.FC<TimerProps> = ({ initialTime }) => {
  // Function to convert HH:MM:SS to seconds
  const convertTimeToSeconds = (timeString: string): number => {
    if (timeString) {
      const parts = timeString?.split(":").map(Number);
      let seconds = 0;

      if (parts?.length === 3) {
        seconds += parts[0] * 3600; // Hours to seconds
        seconds += parts[1] * 60; // Minutes to seconds
        seconds += parts[2]; // Seconds
      } else if (parts?.length === 2) {
        seconds += parts[0] * 60; // Minutes to seconds
        seconds += parts[1]; // Seconds
      } else if (parts?.length === 1) {
        seconds += parts[0]; // Just seconds
      }

      return seconds;
    }
    return 0; // Default to 0 if no time string is provided
  };

  const [time, setTime] = useState(convertTimeToSeconds(initialTime)); // Convert to seconds
  const timerRef = useRef<NodeJS.Timeout | null>(null); // Reference to the interval

  // Start the timer automatically when the component mounts
  useEffect(() => {
    if (time >= 0) {
      timerRef.current = setInterval(() => {
        setTime((prevTime) => prevTime + 1); // Increment time by 1 every second
      }, 1000);
    }

    // Clear the interval when the timer ends or component unmounts
    return () => clearInterval(timerRef.current!);
  }, [time]);

  // Format the time to show only minutes and seconds
  const formatTime = (seconds: number) => {
    if (seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;

      // If there are minutes, display only minutes
      if (minutes > 0) {
        return `${minutes} min`;
      } else {
        // If no minutes, display only seconds
        return `${secs} sec`;
      }
    }
    return "0 sec"; // Return "0 sec" when there is no time
  };

  return (
    <div className="timer-container">
      <h1 className="text-[10] text-xs">{formatTime(time)}</h1>
    </div>
  );
};

export default TimerComponent;
